import React, { useContext, useEffect, useState } from 'react'
import {
  groupSessions as GROUPSESSISSIONIDS,
  sessions as SESSIONS,
} from '../../constants/sessions'
import { GROUPS } from '../../constants/splinterGroups'
import OneBlockComponent from './OneBlockComponents'
import { TalksContext, QuestionsContext } from './context'
import { FirebaseContext } from '../../server/Firebase'
import { useLocation, useNavigate } from 'react-router-dom'

const AllBlocksComponent = ({ splinterGroup }) => {
  const { pathname, hash, key } = useLocation()
  const [selectedSession, setSelectedSession] = useState(
    hash ? hash.slice(1) : ''
  )
  const firebase = useContext(FirebaseContext)
  const navigate = useNavigate()

  const isSplinterGroup = !!GROUPS[splinterGroup]
  let groupSessionIds = isSplinterGroup ? GROUPSESSISSIONIDS[splinterGroup] : []
  let groupSessions = groupSessionIds.map((sess) => SESSIONS[sess])

  const unscheduledBlock = {
    name: 'Unscheduled Talks',
    id: 'unscheduled',
    groups: [splinterGroup],
    rooms: [],
    time: '',
    isJoint: false,
  }
  groupSessions.push(unscheduledBlock)

  useEffect(() => {
    if (hash !== '') {
      setSelectedSession(hash.slice(1))
    }
    return () => {}
  }, [pathname, hash, key, navigate]) // do this on route change

  const SessionTabs = () => {
    return (
      <div className='flex flex-wrap justify-center gap-2 '>
        {groupSessions.map((block) => (
          <div
            className={`p-2 rounded text-center cursor-pointer ${
              selectedSession !== block.id
                ? 'bg-[#8c8cd2]'
                : 'bg-[#2d5e99] text-white border-1 border-black'
            }`}
            onClick={() => navigate('#' + block.id)}
            key={'tab' + block.id + splinterGroup}
          >
            {block.id.charAt(0).toUpperCase() +
              block.id.slice(1).replace('-', ' ')}
          </div>
        ))}
        <div
          className={`py-2 px-4 rounded text-center cursor-pointer ${
            selectedSession !== 'all'
              ? 'bg-[#8c8cd2]'
              : 'bg-[#2d5e99] text-white border-1 border-black'
          }`}
          onClick={() => navigate('#all')}
          key={'all'}
        >
          All
        </div>
      </div>
    )
  }
  return (
    <div>
      <TalksContext.Provider value={firebase.useTalks({ splinterGroup })}>
        <QuestionsContext.Provider
          value={firebase.useQuestions({ splinterGroup })}
        >
          <SessionTabs />
          {groupSessionIds.includes(selectedSession) ? (
            <OneBlockComponent
              block={SESSIONS[selectedSession]}
              splinterGroup={splinterGroup}
            />
          ) : (
            <div>
              {groupSessions.map((block) => (
                <div key={splinterGroup + block.id}>
                  {block.id !== 'unscheduled' ? (
                    <OneBlockComponent
                      block={block}
                      splinterGroup={splinterGroup}
                      key={'oneBlock-' + splinterGroup + block.id}
                    />
                  ) : (
                    <OneBlockComponent
                      block={block}
                      key={'unscheduled' + splinterGroup}
                      splinterGroup={splinterGroup}
                    />
                  )}
                </div>
              ))}
            </div>
          )}
        </QuestionsContext.Provider>
      </TalksContext.Provider>
    </div>
  )
}

export default AllBlocksComponent
